import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Alert, Box, Button, Typography } from "@mui/material";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import { useTranslation } from "react-i18next";
import { StatusCard } from "./marketing/MarketingParts";

export default function PaymentDemo() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [countdown, setCountdown] = useState(3);

  const txId = params.get("txId");
  const amount = params.get("amount");

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      // Auto-redirect to success
      nav("/payment/success");
    }
  }, [countdown, nav]);

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <StatusCard
        icon={<ScienceOutlinedIcon />}
        tone="warning"
        title={t("mkp_demo_title")}
        maxWidth={520}
        actions={
          <>
            <Button variant="contained" onClick={() => nav("/payment/success")}>
              {t("mkp_demo_continue")}
            </Button>
            <Button variant="outlined" onClick={() => nav("/payment/failure")}>
              {t("mkp_demo_fail")}
            </Button>
            <Button variant="text" onClick={() => nav("/plans")}>
              {t("mkp_demo_cancel")}
            </Button>
          </>
        }
      >
        <Alert severity="warning">{t("mkp_demo_warning")}</Alert>

        <Box sx={{ bgcolor: (th) => th.aw.soft, p: 2.5, borderRadius: (th) => `${th.aw.radius.md}px`, textAlign: "center" }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            {t("mkp_tx")}
          </Typography>
          <Typography sx={{ fontFamily: "ui-monospace, Menlo, Consolas, monospace", fontSize: 12, mb: 2, direction: "ltr", overflowWrap: "anywhere" }}>
            {txId}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            {t("mkp_demo_amount")}
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 800, color: "primary.main" }}>
            ₪{amount}
          </Typography>
        </Box>

        <Typography sx={{ textAlign: "center" }}>{t("mkp_demo_iframe")}</Typography>
        <Typography aria-live="polite" sx={{ textAlign: "center", fontWeight: 700 }}>
          {t("mkp_demo_redirect", { n: countdown })}
        </Typography>

        <Alert severity="info">
          <Typography variant="caption" component="span">
            {t("mkp_demo_env")}
            <code style={{ padding: "2px 6px", borderRadius: 4 }}>.env</code>
          </Typography>
        </Alert>
      </StatusCard>
    </Box>
  );
}
